import React from "react"
import dataLayerHelper from "../../helpers/datalayer.helper"
import {
  LinkCardContainer,
  BlogCourseLinkContainer,
  BlogCourseLinkDetails,
  BlogCourseLinkTag,
  BlogLinkTitle,
} from "./link-card.styles"

const LinkCard = ({
  link: { courseImage, courseTitle, courseExcerpt, courseUrl },
}) => (
  <LinkCardContainer>
    <BlogCourseLinkTag
      href={courseUrl}
      onClick={() =>
        dataLayerHelper({
          event: "relatedCourseLinkClick",
          action: "Related Course Link Click",
          label: courseTitle,
        })
      }
    >
      <BlogCourseLinkContainer>
        <img
          src={`${courseImage.file.url}?w=400&fm=webp`}
          alt={courseTitle}
          loading="lazy"
          width="200"
          height="200"
        />
        <BlogCourseLinkDetails>
          <BlogLinkTitle>{courseTitle}</BlogLinkTitle>
          <p>{courseExcerpt}</p>
        </BlogCourseLinkDetails>
      </BlogCourseLinkContainer>
    </BlogCourseLinkTag>
  </LinkCardContainer>
)

export default LinkCard
